<template>
  <v-container class="pa-5">
    <v-card class="pa-3">
      <v-card-text class="text-center">
        <v-avatar size="40" color="red">
          <v-icon size="30" color="white">mdi-close</v-icon>
        </v-avatar>
        <div class="subtitle-1 mt-5 font-weight-regular black--text">Kuisioner Tidak Ditemukan</div>
        <div>
          Maaf, tampaknya ada masalah dengan pengisian kuesioner Anda. Silakan periksa kembali kuisioner di lain waktu
        </div>
        <div class="white--text"> kuesioner_success </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  mounted() {
    setTimeout(() => {
      if (window && window.webkit) {
        window.webkit.messageHandlers.bridge.postMessage('kuesioner_success')
      }
    }, 1000)
  },
}
</script>
